import React from "react";

import { REPLY_LENGTH_OPTIONS } from "../../config/replyLengthOptions";
import { TONE_OPTIONS } from "../../config/toneOptions";

export function OnboardingReplyStyleStep({ formState, setFormState }) {
  return (
    <section className="space-y-8">
      <div>
        <h1 className="font-display font-bold italic text-[40px] leading-[1.1] text-theme-on-background mb-2">
          How should your replies sound?
        </h1>
        <p className="font-mono text-[12px] text-theme-muted mb-4">
          Choose a persona for your AI-drafted replies. Drafts don&apos;t send automatically until you send them.
        </p>
      </div>

      <div>
        <h2 className="mb-1.5 font-mono text-[11px] font-normal uppercase tracking-[0.1em] text-theme-muted">Tone</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-1 items-start">
          {TONE_OPTIONS.map((tone) => {
            const selected = formState.tone === tone.value;
            return (
              <button
                key={tone.value}
                type="button"
                title={`${tone.title}. ${tone.subtitle}`}
                className={`flex flex-col items-start text-left p-4 rounded-xl border transition-colors ${
                  selected
                    ? "border-theme-accent bg-theme-accent-muted"
                    : "border-theme-border bg-theme-surface hover:border-theme-border-bright"
                }`}
                onClick={() => setFormState({ ...formState, tone: tone.value })}
              >
                <div className="w-9 h-9 rounded border border-theme-border flex items-center justify-center mb-3">
                  <span className="material-symbols-outlined text-theme-muted text-base">{tone.icon}</span>
                </div>
                <p className="font-display font-semibold text-sm text-theme-on-background mb-2">{tone.compactName}</p>
                <p className="font-mono text-[11px] text-theme-muted italic leading-snug">{tone.example}</p>
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h2 className="mb-1.5 font-mono text-[11px] font-normal uppercase tracking-[0.1em] text-theme-muted">
          Reply length
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-1">
          {REPLY_LENGTH_OPTIONS.map((opt) => {
            const selected = formState.reply_length === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                className={`text-left p-5 rounded-xl border transition-colors ${
                  selected
                    ? "border-theme-accent bg-theme-accent-muted"
                    : "border-theme-border bg-theme-surface hover:border-theme-border-bright"
                }`}
                onClick={() => setFormState({ ...formState, reply_length: opt.value })}
              >
                <h3 className="font-display font-bold text-base mb-1">{opt.title}</h3>
                <p className="font-mono text-[11px] text-theme-muted italic leading-snug">{opt.subtitle}</p>
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h2 className="mb-1.5 font-mono text-[11px] font-normal uppercase tracking-[0.1em] text-theme-muted">
          Customization
        </h2>
        <textarea
          className="flipmail-text-input mt-1 w-full resize-y rounded-xl border border-theme-border bg-theme-surface px-4 py-3 font-mono text-sm text-theme-text placeholder:text-theme-dim focus:border-theme-accent focus:outline-none focus:ring-1 focus:ring-theme-accent/60"
          rows={4}
          aria-label="Customization"
          placeholder="Example: Always include a link to our website, and sign off with a call to action."
          value={formState.reply_custom_context}
          onChange={(e) => setFormState({ ...formState, reply_custom_context: e.target.value })}
        />
      </div>
    </section>
  );
}
